import _ from 'lodash';

import { AdjustmentType } from './adjustment-type.model';
import { Adjustment } from './adjustment.model';
import { EnrollmentGroup } from './enrollment-group.model';
import { DisturbanceReport } from './disturbance-report.model';
import { DocumentType } from './document-type.model';
import { Document } from './document.model';
import { DocusignTemplate } from './docusign-template.model';
import { EmailTemplate } from './email-template.model';
import { IneligibleAreaUser } from './ineligible-area-user.model';
import { LegalPage } from './legal-page.model';
import { Parcel } from './parcel.model';
import { PaymentPeriod } from './payment-period.model';
import { PeriodicReport } from './periodic-report.model';
import { PremiumAcreageUser } from './premium-acreage-user.model';
import { Program } from './program.model';
import { ProspectiveUser } from './prospective-user.model';
import { Region } from './region.model';
import { ReportConfig } from './report-config.model';
import { ReportResponse } from './report-response.model';
import { Report } from './report.model';
import { SiteDocusignEnvelope } from './site-docusign-envelope.model';
import { SiteNote } from './site-note.model';
import { SitePayment } from './site-payment.model';
import { SiteStatusLog } from './site-status-log';
import { SiteVerificationVisit } from './site-verification-visit.model';
import { Site, SiteAvailableEnrollmentGroupRow } from './site.model';
import { SiteReviewCheck } from './site_review_check.model';
import { SiteReviewNote } from './site_review_note.model';
import { Stand } from './stand.model';
import { Strata } from './strata.model';
import { StripeAccount } from './stripe-account.model';
import { UserActivity } from './user-activity.model';
import { User } from './user.model';
import { Version } from './version.model';
import { YieldCurve } from './yield-curve.model';
import { WelcomeDocument } from './welcome-document.model';

import { CountyInfo } from '@core/api/gis.service';
import { Dashboard } from "./dashboard.model";
import { AcrProject } from "./acr-project.model";
import { AcrStrataVersion } from "./acr-strata-version.model";
import { AcrReportingPeriod } from "./acr-reporting-period.model";
import { AcrVintage } from "./acr-vintage.model";
import { AppConfig } from "./app-config.model";
import { ComponentContent } from '@shared/models/component-content.model';
import { SiteBase } from '@shared/models/site-base.model';
import { Faq } from '@shared/models/faq.model';

export const mappedClasses = [
  AcrProject,
  AcrReportingPeriod,
  AcrVintage,
  AcrStrataVersion,
  Adjustment,
  AdjustmentType,
  AppConfig,
  ComponentContent,
  EnrollmentGroup,
  SiteAvailableEnrollmentGroupRow,
  CountyInfo,
  Dashboard,
  DisturbanceReport,
  Document,
  DocumentType,
  DocusignTemplate,
  EmailTemplate,
  IneligibleAreaUser,
  Faq,
  LegalPage,
  Parcel,
  PaymentPeriod,
  PeriodicReport,
  PremiumAcreageUser,
  Program,
  ProspectiveUser,
  ReportConfig,
  Region,
  Report,
  ReportResponse,
  SiteBase,
  Site,
  SiteDocusignEnvelope,
  SiteNote,
  SitePayment,
  SiteStatusLog,
  SiteVerificationVisit,
  SiteReviewCheck,
  SiteReviewNote,
  Stand,
  Strata,
  StripeAccount,
  User,
  UserActivity,
  Version,
  YieldCurve,
  WelcomeDocument,
];

// List of fields that should not be serialized
const noSerializationFields = ['feature', 'defaultState'];

export function deserialize(obj: any, targetClass: any) {
  if (Array.isArray(obj)) {
    return obj.map(item => deserialize(item, targetClass));
  }
  if (obj !== null && obj.constructor === Object) {
    let result = {};
    for (let [key, value] of Object.entries(obj)) {
      const camelKey = _.camelCase(key);
      const propType = Reflect.getMetadata('design:type', targetClass.prototype, camelKey);

      if (propType && mappedClasses.includes(propType)) {
        if (Array.isArray(value)) {
          result[camelKey] = value.map(v => deserialize(v, propType));
        } else {
          result[camelKey] = deserialize(value, propType);
        }
      } else {
        result[camelKey] = value;
      }
    }
    return new targetClass(result);
  }
  return obj;
}

export function serialize(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(item => serialize(item));
  }
  if (obj !== null && obj instanceof Object && Object.entries(obj).length > 0) {
    let result = {};
    for (let [key, value] of Object.entries(obj)) {
      const snakeKey = key.replace(/([a-z])([A-Z0-9])/g, '$1_$2').toLowerCase();
      if (Array.isArray(value) && noSerializationFields.indexOf(key) === -1) {
        result[snakeKey] = value.map(item => serialize(item));
      } else if (value instanceof Object && noSerializationFields.indexOf(key) === -1) {
        result[snakeKey] = serialize(value);
      } else {
        result[snakeKey] = value;
      }
    }
    return result;
  }
  return obj;
}
